import { render } from "./BadgesForm.vue?vue&type=template&id=524d80c0"
import script from "./BadgesForm.vue?vue&type=script&lang=js"
export * from "./BadgesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__